/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useEffect, useContext, useState } from 'react';
import { Form, FormGroup, Input, InputGroup, InputGroupAddon, Label, Button, Pagination, PaginationItem, PaginationLink, Modal, ModalHeader, ModalBody, Col } from 'reactstrap';
import moment from 'moment';
import Alert from 'react-s-alert';

// context imports
import { ThemeContext } from '../../contexts/ThemeContext'

// import services
import AdminService from '../../services/AdminService';
import GeneralService from '../../services/GeneralService';

// local imports
import ErrorBoundary from '../general/ErrorBoundary';

const GiftVouchers = props => {

    // variables
    let timeout = 0;

    // states
    const [giftVouchers, setGiftVouchers] = useState([]);

    const [isLoading, setIsLoading] = useState(false);
    const [isLoading2, setIsLoading2] = useState([]);
    const [isLoading3, setIsLoading3] = useState(false);
    const [modal, setModal] = useState({ isVisible: false, data: { from: '', to: '', code: '', amount: 0, qty: 0, payment_id: '', notes: { your_name: '', email: '', phone: '', email_of_receiver: '', name_of_receiver: '', notes_for_receiver: '' }, sentToUser: false } });
    const [pagination, setPagination] = useState({ limit: 10, page: 1 });
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');

    // contexts
    const { theme } = useContext(ThemeContext);

    // use Effects
    useEffect(() => {
        handleSearchSubmit(null);
    }, [pagination.page, pagination.limit]);

    // utility functions
    const generateCode = () => {
        try {
            var chars = '0123456789aAbBcCdDeEfFgGhHiIjJkKlLmMnNoOpPqQrRsStTuUvVwWxXyYzZ';
            let CODE = '';
            for (let i = 0; i < 18; i++) {
                CODE += chars[Math.floor(Math.random() * 62)];
            }
            setModal({ ...modal, data: { ...modal.data, code: CODE } });
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Admin GiftVouchers generateCode', 'Error in try catch block', err.stack);
        }
    }

    // handle functions
    const handleChange = e => {
        try {
            setModal({ ...modal, data: { ...modal.data, [e.target.name]: e.target.value } });
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Admin GiftVouchers handleChange', 'Error in try catch block', err.stack);
        }
    }

    const handleNotesChange = e => {
        try {
            setModal({ ...modal, data: { ...modal.data, notes: { ...modal.data.notes, [e.target.name]: e.target.value } } });
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Admin GiftVouchers handleNotesChange', 'Error in try catch block', err.stack);
        }
    }

    const handlePagination = (e, index) => {
        e.preventDefault();
        try {
            setPagination({ ...pagination, page: index });
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Admin GiftVouchers handlePagination', 'Error in try catch block', err.stack);
        }
    }

    const handleSearchSubmit = e => {
        if (e) e.preventDefault();
        if (!isLoading) {
            setIsLoading(true);
            try {
                AdminService.getGiftVouchers(pagination.limit, pagination.page, fromDate, toDate).then(data => {
                    setGiftVouchers(data.giftVouchers);
                    if (data.pagination.totalPages <= data.pagination.page) {
                        data.pagination.page = data.pagination.totalPages;
                    }
                    setPagination(data.pagination);
                    setIsLoading(false);
                });
            } catch (err) {
                Alert.error("Some error occured, please try again later or report support team.", {
                    position: 'top-right',
                    effect: 'slide'
                });
                setIsLoading(false);
                GeneralService.logError('at Admin GiftVouchers handleSearchSubmit', 'Error in try catch block', err.stack);
            }
        }
    }

    const handleGiftVoucherSubmit = e => {
        e.preventDefault();
        try {
            setIsLoading3(true);
            AdminService.addGiftVoucher(modal.data).then(data => {
                setModal({ isVisible: false, data: { from: '', to: '', code: '', amount: 0, qty: 0, payment_id: '', notes: { your_name: '', email: '', phone: '', email_of_receiver: '', name_of_receiver: '', notes_for_receiver: '' }, sentToUser: false } });
                handleSearchSubmit(e);
                Alert.info(data.message.msgBody, {
                    position: 'top-right',
                    effect: 'slide'
                });
                setIsLoading3(false);
            }).catch(error => {
                Alert.error(error.message.msgBody, {
                    position: 'top-right',
                    effect: 'slide'
                });
                setIsLoading3(false);
            });
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            setIsLoading3(false);
            GeneralService.logError('at Admin GiftVouchers handleGiftVoucherSubmit', 'Error in try catch block', err.stack);
        }
    }

    const handleSendToUser = (id, index) => {
        try {

            setIsLoading2({...isLoading2, [index]: true});
            AdminService.sendGiftVoucher(id).then(data => {
                let tempArray = [...giftVouchers];
                tempArray[index].sentToUser = true;
                setGiftVouchers(tempArray);
                Alert.info(data.message.msgBody, {
                    position: 'top-right',
                    effect: 'slide'
                });
                setIsLoading2({...isLoading2, [index]: false});
            }).catch(error => {
                Alert.error(error.message.msgBody, {
                    position: 'top-right',
                    effect: 'slide'
                });
                setIsLoading2({...isLoading2, [index]: false});
            });
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            setIsLoading2({...isLoading2, [index]: false});
            GeneralService.logError('at Admin GiftVouchers handleSendToUser', 'Error in try catch block', err.stack);
        }
    }

    return (
        <main>
            <div className="container-fluid">
                <h3 className="my-4">GiftVouchers</h3>
                <div className="card mb-4">
                    <div className="card-header d-flex">
                        <label className="my-auto">GiftVoucher List</label>
                        <Button className="ml-auto my-auto px-3" type="button" style={Object.assign({ height: 'fit-content' }, theme.formButton)} onClick={() => setModal({ isVisible: true, data: { from: '', to: '', code: '', amount: 0, qty: 0, payment_id: '', notes: { your_name: '', email: '', phone: '', email_of_receiver: '', name_of_receiver: '', notes_for_receiver: '' }, sentToUser: false } })}>Add</Button>
                    </div>
                    <div className="card-body py-0">
                        <div className="table-responsive">
                            <table className="table table-bordered mb-0" id="dataTable" width="100%" cellSpacing="0">
                                <thead>
                                    <tr>
                                        <td colSpan="8" className="border-0 px-0">
                                            <Form inline className="d-flex" onSubmit={handleSearchSubmit}>
                                                <FormGroup className="mr-2">
                                                    <Label style={theme.formBodyText} className="mr-1" >From</Label>
                                                    <Input type="date" id="fromDate" name="fromDate" value={fromDate} onChange={(e) => setFromDate(e.target.value)} className="form-control" style={theme.formInput} required />
                                                </FormGroup>
                                                <FormGroup className="mr-2">
                                                    <Label for="toDate" style={theme.formBodyText} className="mr-1" >To</Label>
                                                    <Input type="date" id="toDate" name="toDate" value={toDate} onChange={(e) => setToDate(e.target.value)} className="form-control" style={theme.formInput} required />
                                                </FormGroup>
                                                <Button type="submit" className="my-auto" style={Object.assign({ height: 'fit-content' }, theme.formButton)} disabled={isLoading}>{isLoading ? <span className="spinner-border spinner-border-sm mr-1" disabled={isLoading}></span> : null}Search</Button>
                                                <Button type="button" className="ml-auto my-auto" style={Object.assign({ height: 'fit-content' }, theme.formButton)} onClick={handleSearchSubmit} disabled={isLoading}>{isLoading ? <span className="spinner-border spinner-border-sm mr-1"></span> : null}Refresh</Button>
                                            </Form>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Code</th>
                                        <th>Amount</th>
                                        <th>Buyer's email</th>
                                        <th>Validity</th>
                                        <th>Payment Id</th>
                                        <th style={{ width: '7rem' }}></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        giftVouchers.map((item, index) => (
                                            <ErrorBoundary errorAt={`At Admin GiftVouchers Table${index}`}>
                                                <tr key={index}>
                                                    <td>{item.code}</td>
                                                    <td>₹{item.amount}</td>
                                                    <td>{item.notes.email}</td>
                                                    <td>{item.from && item.to ? `${moment(item.from).format('DD-MM-YYYY')} to ${moment(item.to).format('DD-MM-YYYY')}` : ''}</td>
                                                    <td>{item.payment_id}</td>
                                                    <td><Button type="button" disabled={(item.code && item.qty > 0) || !isLoading2[index] ? false : true} style={theme.formButton} onClick={() => handleSendToUser(item._id, index)} >{isLoading2[index] ? <span className="spinner-border spinner-border-sm mr-1"></span> : null}{item.sentToUser ? 'Send to user again' : 'Send to user'}</Button></td>
                                                </tr>
                                            </ErrorBoundary>
                                        ))
                                    }
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td colSpan="8" className="border-0 pb-0">
                                            <div className="d-flex">
                                                {/* <div className="d-flex p-2">
                                                    <span>Showing {pagination.totalResults==0 ? 0 : 1 } to</span>
                                                    <Input style={{width:'47px', height: '30px', padding: '14px 5px', margin: '0 5px'}} id="limit" minLength="1" maxLength="4" name="limit" value={pagination.limit>pagination.totalResults ? pagination.totalResults : pagination.limit} onChange={e => handlePagination(e,null)} ></Input>
                                                    <span>of {pagination.totalResults} entries</span>
                                                </div> */}
                                                <ErrorBoundary errorAt="At Admin GiftVouchers Pagination">
                                                    <div className="p-2">Showing {pagination.totalResults == 0 ? 0 : (1 + (10 * (pagination.page - 1)))} to {(pagination.limit + (10 * (pagination.page - 1))) > pagination.totalResults ? pagination.totalResults : (pagination.limit + (10 * (pagination.page - 1)))} of {pagination.totalResults} entries</div>
                                                    <Pagination aria-label="Page navigation example" className="ml-auto">
                                                        <PaginationItem disabled={pagination.page == 1}>
                                                            <PaginationLink
                                                                onClick={e => handlePagination(e, pagination.page - 1)}
                                                                previous
                                                                href="#" />
                                                        </PaginationItem>
                                                        {[...Array(pagination.totalPages)].map((page, i) =>
                                                            <PaginationItem active={i + 1 === pagination.page} key={i}>
                                                                <PaginationLink onClick={e => handlePagination(e, i + 1)} href="#">
                                                                    {i + 1}
                                                                </PaginationLink>
                                                            </PaginationItem>
                                                        )}
                                                        <PaginationItem disabled={pagination.page == pagination.totalPages}>
                                                            <PaginationLink
                                                                onClick={e => handlePagination(e, pagination.page + 1)}
                                                                next
                                                                href="#" />
                                                        </PaginationItem>
                                                    </Pagination>
                                                </ErrorBoundary>
                                            </div>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <ErrorBoundary errorAt="At Admin GiftVouchers Modal">
                <Modal size="lg" isOpen={modal.isVisible} backdrop={true}>
                    <ModalHeader close={<span className="ml-3" style={{ cursor: "pointer" }} onClick={() => setModal({ isVisible: false, data: { from: '', to: '', code: '', amount: 0, qty: 0, payment_id: '', notes: { your_name: '', email: '', phone: '', email_of_receiver: '', name_of_receiver: '', notes_for_receiver: '' }, sentToUser: false } })}><i className="fas fa-times"></i></span>}><span style={theme.headingBold}>Data</span></ModalHeader>
                    <ModalBody>
                        <Form onSubmit={handleGiftVoucherSubmit}>
                            <FormGroup>
                                <Label for="from" style={theme.formBodyText} >From</Label>
                                <Input type="date" name="from" value={modal.data.from} onChange={handleChange} className="form-control" style={theme.formInput} required />
                            </FormGroup>

                            <FormGroup>
                                <Label for="to" style={theme.formBodyText} >To</Label>
                                <Input type="date" name="to" value={modal.data.to} onChange={handleChange} className="form-control" style={theme.formInput} required />
                            </FormGroup>

                            <FormGroup>
                                <Label for="code" style={theme.formBodyText} >Code</Label>
                                <InputGroup>
                                    <Input type="text" name="code" value={modal.data.code} onChange={handleChange} className="form-control" style={theme.formInput} required />
                                    <InputGroupAddon addonType="append" className="ml-2">
                                        <Button type="button" style={theme.formButton} onClick={generateCode}>Generate</Button>
                                    </InputGroupAddon>
                                </InputGroup>
                            </FormGroup>

                            <FormGroup>
                                <Label for="amount" style={theme.formBodyText} >Amount</Label>
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">₹</InputGroupAddon>
                                    <Input type="number" min={0} name="amount" value={modal.data.amount} onChange={handleChange} className="form-control" style={{ borderTopRightRadius: '10px', borderBottomRightRadius: '10px' }} required />
                                </InputGroup>
                            </FormGroup>

                            <FormGroup>
                                <Label for="qty" style={theme.formBodyText} >Quantity</Label>
                                <Input type="number" name="qty" value={modal.data.qty} onChange={handleChange} className="form-control" style={theme.formInput} required />
                            </FormGroup>

                            <FormGroup>
                                <Label for="payment_id" style={theme.formBodyText} >Payment Id</Label>
                                <Input type="text" name="payment_id" value={modal.data.payment_id} onChange={handleChange} className="form-control" style={theme.formInput} required />
                            </FormGroup>

                            <FormGroup>
                                <Label for="notes" style={theme.formBodyText} >Notes</Label>
                                <div style={{ border: '1px solid #ced4da', padding: '1rem', borderRadius: '10px' }}>
                                    <FormGroup row>
                                        <Label for="your_name" sm={3} style={theme.formBodyText} >Your Name</Label>
                                        <Col sm={9}>
                                            <Input type="text" name="your_name" id="your_name" value={modal.data.notes.your_name} className="form-control" style={theme.formInput} onChange={handleNotesChange} required />
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                        <Label for="email" sm={3} style={theme.formBodyText} >Email</Label>
                                        <Col sm={9}>
                                            <Input type="text" name="email" id="email" value={modal.data.notes.email} className="form-control" style={theme.formInput} onChange={handleNotesChange} required />
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                        <Label for="phone" sm={3} style={theme.formBodyText} >Phone</Label>
                                        <Col sm={9}>
                                            <Input type="text" name="phone" id="phone" value={modal.data.notes.phone} className="form-control" style={theme.formInput} onChange={handleNotesChange} required />
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                        <Label for="email_of_receiver" sm={3} style={theme.formBodyText} >Email Of Receiver</Label>
                                        <Col sm={9}>
                                            <Input type="text" name="email_of_receiver" id="email_of_receiver" value={modal.data.notes.email_of_receiver} className="form-control" style={theme.formInput} onChange={handleNotesChange} required />
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                        <Label for="name_of_receiver" sm={3} style={theme.formBodyText} >Name Of Receiver</Label>
                                        <Col sm={9}>
                                            <Input type="text" name="name_of_receiver" id="name_of_receiver" value={modal.data.notes.name_of_receiver} className="form-control" style={theme.formInput} onChange={handleNotesChange} required />
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                        <Label for="notes_for_receiver" sm={3} style={theme.formBodyText} >Notes For Receiver</Label>
                                        <Col sm={9}>
                                            <Input type="text" name="notes_for_receiver" id="notes_for_receiver" value={modal.data.notes.notes_for_receiver} className="form-control" style={theme.formInput} onChange={handleNotesChange} required />
                                        </Col>
                                    </FormGroup>
                                </div>
                            </FormGroup>

                            <Label style={theme.formBodyText}>Gift card is sent to user : {modal.data.sentToUser ? 'Yes' : 'No'}</Label><br />

                            <Button type="submit" className="mt-1" style={theme.formButton} disabled={isLoading3}>{isLoading3 ? <span className="spinner-border spinner-border-sm mr-1"></span> : null}Submit</Button>
                        </Form>
                    </ModalBody>
                </Modal>
            </ErrorBoundary>
        </main>
    )

}

export default GiftVouchers;